export default "__VITE_ASSET__VO9A5f01__"